'use client';
import { useEffect, useState } from 'react';
import { rewardRedeemRuleList } from './apis';
import ListCard from './ListCard';
import MoreBtn from './MoreBtn';
import CreditsLine from './CreditsLine';
import getLocal from '@/app/utils/getLocal';
import { injectNotes } from '../util';

export default function TabContentA({ data = {}, creditsData, winCallback, itemCallback }: any) {
    const { locale } = getLocal();
    const [listA, setListA] = useState<any[]>([]);
    const [isCenter, setIsCenter] = useState(true);
    useEffect(() => {
        const initFn = async () => {
            const res = await rewardRedeemRuleList(locale, `/${locale}/members-day`);
            if (res.code === '0') {
                const listA = injectNotes(res.data || [], locale);
                setListA(listA);
                if (window?.innerWidth > 1024) {
                    setIsCenter(listA?.length <= 4);
                } else {
                    setIsCenter(listA?.length <= 2);
                }
                // 没有数据,临时隐藏
                if (listA.length === 0) {
                    document.querySelector('#activity-eco-redeem-rewards')?.classList.add('hide-content');
                }
            }
        };
        if (typeof window !== 'undefined') {
            initFn();
        }
    }, []);
    return (
        <>
            <div className="eco-redeem-rewards-more-box">
                <CreditsLine creditsData={creditsData} />
                <MoreBtn winCallback={winCallback} />
            </div>
            <div className={`eco-redeem-rewards-list ${isCenter ? 'center' : 'left'}`}>
                {listA.map((item: any, index: number) => {
                    return (
                        <div className={`eco-redeem-rewards-item eco-redeem-rewards-item-${index + 1}`} key={index}>
                            <ListCard data={item} creditsData={creditsData} locale={locale} itemCallback={itemCallback} tabType="tabA" />
                        </div>
                    );
                })}
            </div>
        </>
    );
}
